export default __webpack_public_path__ + "static/media/card2.8183f999.png";